import React from "react";
import { createRoot } from "react-dom/client";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
//import { createHashRouter, RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";
import "semantic-ui-css/semantic.min.css";
import "./index.css";
import App from "./app/App";
import * as serviceWorker from "./serviceWorker";
import { configureStore } from "./store/configureStore";

const store = configureStore();

const rootEl = document.getElementById("root");

const root = createRoot(rootEl);

//const router = createHashRouter([
//  {
//    path: "/",
//    element: <App />,
//  },
//]);
//
//root.render(
//  <Provider store={store}>
//    <RouterProvider router={router} />
//  </Provider>
//);

root.render(
  <Provider store={store}>
    <Router basename={"/"}>
      <Routes>
        <Route path="/*" element={<App />}></Route>
      </Routes>
    </Router>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
